<template>
  <div>
    <b-card>
      <b-row>
        <b-col>
          <b-form-group id="name-group-1" label="عنوان نمودار: " label-for="name">
            <b-form-input id="name" required v-model="bi.name" placeholder="عنوان نمودار "></b-form-input>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="source_id-group-1" label="منبع: " label-for="source_id">
            <b-form-select
              @change="SourceChanged"
              id="source_id"
              value-field="id"
              text-field="name"
              v-model="bi.source_id"
              :options="sourses"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group id="name-group-1" label="نوع نمودار: " label-for="name">
            <MDDropdown v-bind:group="100" v-model="bi.mdid100_type"></MDDropdown>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-group label="ستون ها:">
            <b-form-checkbox
              v-for="option in y_fields"
              v-model="bi.yAxis"
              :key="option.id"
              :value="option"
              name="flavour-3a"
            >{{ option.name }}</b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="سطر ها:">
            <b-form-radio
              v-for="option in x_fields"
              v-model="bi.xAxis"
              :key="option.id"
              :value="option.field_name"
              name="flavour-2a"
            >{{ option.name }}</b-form-radio>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="شرط ها:">
            <b-form-checkbox
              v-for="option in x_fields"
              v-model="bi.conditions"
              :key="option.id"
              :value="option"
              name="flavour-3a"
            >{{ option.name }}</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-button variant="success" @click="Save">ذخیره</b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "../../helpers/httpHelper";
import MDDropdown from "../../components/MDDropdown";
import _ from "lodash";
export default {
  data() {
    return {
      bi: {
        name: "",
        source_id: 0,
        xAxis: {},
        yAxis: [],
        conditions: [],
        mdid100_type: 0
      },
      fields: [],
      sourses: [],
      x_fields: [],
      y_fields: []
    };
  },
  methods: {
    SourceChanged() {
      var sid = this.bi.source_id;
      this.fields = this.sourses.find(function(element) {
        return element.id == sid;
      }).fields;
      this.x_fields = _.filter(this.fields, function(o) {
        return o.is_x_axis == 1;
      });
      this.y_fields = _.filter(this.fields, function(o) {
        return o.is_x_axis == 0;
      });
    },
    Save() {
      this.bi.xAxis = this.bi.xAxis;
      // httpHelper.postData("BI", this.bi).then(res => {
      //   this.$router.push("/dashboard");
      // });
    }
  },
  mounted() {
    httpHelper.getData("BI/source").then(res => {
      this.sourses = res.result;
      if (this.$route.params.id != null) {
        httpHelper.getData("BI?id=" + this.$route.params.id).then(res => {
          //this.sourses = res.result;
          this.bi = res.result;
          this.SourceChanged();
          this.bi.conditions = eval("(" + this.bi.condition + ")");
          this.bi.xAxis = this.bi.x_axis;//eval("(" + this.bi.x_axis + ")");
          this.bi.yAxis = eval("(" + this.bi.y_axis + ")");
        });
      }
    });
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "صفحه اصلی", route: "/dashboard" },
      { title: "اضافه کردن نمودار به صفحه اصلی" }
    ]);
  },
  components: {
    MDDropdown
  },
  name: "AddEditBI"
};
</script>